import { AiOutlineCloseCircle } from "react-icons/ai";
import Modal from "../../common/Modal";
import GeneralInput from "../../common/GeneralInput";
import dollar from '../../../assets/common/dollar.svg'
import { ChangeEvent, FormEvent, useEffect, useMemo, useState } from "react";
import * as CommonTypes from '../../../types/common.types'
import styled from "styled-components";
import { useGlobal } from "../../../context/global";
import ToursService from "../../../services/tours.service";
import Select from "../../common/Select";
import { useAlly } from "../../../context/ally";
import AllyService from "../../../services/ally.service";

export default function TicketPaymentGroup() {
    const { setMessage, setIsLoading } = useGlobal()
    const { newGroup, setNewGroupReservations, setSummary, setIsConfirmBoucherModalOpen, 
        setIsTicketPaymentGroupModalOpen, newGroupReservationData, setNewGroupReservationData, user } = useAlly()
    const [tour, setTour] = useState<CommonTypes.TourInfo>()
    const [me, setMe] = useState<CommonTypes.Ally>()

    useEffect(() => {
        async function fetchTours() {
            console.log(newGroupReservationData?.tour_id, user?.user.agency_id)
            try {
                const response = await ToursService.getDetailTourInfo(newGroupReservationData?.tour_id || '', user?.user.agency_id || '')
                setTour(response.data)
                const responseMe = await AllyService.me()
                setMe(responseMe.data)
            } catch (error) {
                console.error('Error fetching tours:', error)
            }
        }
        fetchTours()
    }, [newGroupReservationData?.tour_id, user?.user.agency_id])

    function onChange(e: ChangeEvent<HTMLInputElement>) {
        const value = e.target.value
        const name = e.target.name
        setNewGroupReservationData({...newGroupReservationData, [name]: value})
    }

    const price = useMemo(() => {
        if (!me || !newGroupReservationData) return 0
        const price = me?.tour_prices?.find(tp => tp.tour_id === newGroupReservationData?.tour_id)?.price || 0
        return price
    }, [me, newGroupReservationData])

    async function onSubmit(e: FormEvent<HTMLFormElement>) {
        e.preventDefault()
        console.log(newGroup);
        console.log(newGroupReservationData);
        console.log(tour);
        // Antes estos casos cortaban con un return mudo: el botón no hacía nada y el aliado no sabía
        // por qué (le pasó a un aliado real con un tour sin precio configurado en su ficha).
        if (!price) {
            setMessage({
                type: 'error',
                content: 'Este tour no tiene un precio asignado para ti. Contacta a la agencia para que lo configure.'
            })
            setTimeout(() => setMessage(undefined), 8000)
            return
        }
        if (!newGroupReservationData || newGroupReservationData.ticket_included === undefined) {
            setMessage({ type: 'error', content: 'Indica si la entrada va incluida (INCLUIDO / LLEVA CASH).' })
            setTimeout(() => setMessage(undefined), 5000)
            return
        }
        if (!newGroup.length) return
        setIsLoading(true)
        try {
            for (let i = 0; i < newGroup.length; i++) {
                const passenger = newGroup[i];
                const submittingData = {
                    passenger_id: passenger.id,
                    price: price,
                    tickets: 0,
                    payment_methods: [{ name: 'Deuda', value: price }],
                    tour_id: newGroupReservationData.tour_id,
                    reservation_date: newGroupReservationData.reservation_date,
                    ticket_included: newGroupReservationData.ticket_included,
                    group_id: newGroupReservationData.group_id,
                } as CommonTypes.SubmitReservation
                const response = await (await AllyService.createReservation(submittingData)).data
                setSummary(prev => ([...prev, response]))
                setMessage({
                    type: 'success',
                    content: 'Passengers successfully assigned to tour'
                })
                console.log(response)
                setNewGroupReservations(prev => [...prev, {
                    id: response.reservation.id,
                    price: price,
                    tickets: newGroupReservationData.tickets || 0,
                    ticket_included: newGroupReservationData.ticket_included || false,
                    tour_id: newGroupReservationData.tour_id,
                    reservation_date: newGroupReservationData.reservation_date,
                    payment_methods: [{ name: 'Deuda', value: price }],
                } as CommonTypes.Reservation])
            }
            setIsConfirmBoucherModalOpen(true)
        } catch (error: any) {
            // El backend manda un texto claro para errores conocidos (ej. pasajero que ya tiene ese
            // tour esa fecha, precio distinto al configurado) — mostrarlo en vez del genérico.
            const serverMessage = error?.response?.status < 500 && typeof error?.response?.data === 'string'
                ? error.response.data
                : undefined
            setMessage({
                type: 'error',
                content: serverMessage || 'An error occurred, please try again'
            })
        }
        finally {
            setIsLoading(false)
            setTimeout(() => setMessage(undefined), 5000)
        }
        console.log(newGroupReservationData)
        
    }
    console.log(tour)
    return (
        <Modal onSubmit={onSubmit}>
            <h1>Payment</h1>
            <h3>Prices per passenger, not general*</h3>
            <Select 
            options={[{name: 'INCLUIDO', value: 'true'}, {name: 'LLEVA CASH', value: 'false'}]}
            label="Ticket included"
            onChange={e => setNewGroupReservationData(prev => ({...prev, ticket_included: e.target.value === 'true'}))}
            defaultNull
            defaultValue={''}
            />
            <GeneralInput
            label="Total Price*"
            placeholder="$20000"
            value={price}
            name="price"
            type="number"
            image={dollar}
            disabled={true}
            style={{margin: '20px 0'}}
            />
            <div className="actions">
                <button type="submit">Continue</button>
            </div>
            <div className="close" 
            onClick={() => setIsTicketPaymentGroupModalOpen(false)}
            title="close">
                <AiOutlineCloseCircle/>
            </div>
        </Modal>
    )
}

const PaymentMethod = styled.div`
margin-bottom: 10px;
position: relative;
button {
    position: absolute;
    right: 0;
    top: 0;
    height: 25px;
    width: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    background-color: rgba(0,0,0,0);
    border-radius: 50%;
    cursor: pointer;
    border: 1px solid ${props => props.theme.dark};
}
h4 {
    font-weight: 400;
    margin-bottom: 5px;
}
label {
    text-transform: capitalize;
    }
`